import { Trans } from '@lingui/react'
import { type FC } from 'react'

import MountPoints from 'shared/utils/mountPoints'
import Button from 'views/components/atoms/Button'
import Form from 'views/components/atoms/Form'
import InputTextWithWithFloatingLabel from 'views/components/molecules/InputTextWithFloatingLabel'
import withMountPoints from 'views/enhancers/withMountPoints'

type NewsletterModalFormProps = {
  mountPoints: MountPoints
}

const NewsletterModalForm: FC<NewsletterModalFormProps> = ({ mountPoints }) => {
  return (
    <Form
      name="newsletter-form"
      data-clientside-hook="formValidation newsletterModalForm"
      method="GET"
      action={mountPoints.getNewsletter()}
      noValidate
      className="l-flex@medium l-flex--center"
    >
      <div className="l-flex l-flex--wrap l-col--6-of-12@medium">
        <div className="l-col--12-of-12 u-margin--bottom">
          <InputTextWithWithFloatingLabel
            name="email"
            id="newsletterEmail"
            inputType="email"
            required
          >
            <Trans id="general.label.email" />
          </InputTextWithWithFloatingLabel>
        </div>
        <div className="l-col--6-of-12 u-padding-xx-small--left u-margin--auto">
          <Button
            className="m-NewsletterModal_submitButton"
            id="submit"
            type="submit"
          >
            <Trans id="checkout.error.requestBody.validation.email.login" />
          </Button>
        </div>
      </div>
    </Form>
  )
}

export default withMountPoints(NewsletterModalForm)
